import React from 'react';
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

import { t } from 'services/translation';
import { LOGIN } from './routes';
import { InlineLink, InlineAnchor } from './styles_auth';

const SubfooterStyled = styled.div`
  color: ${Theme.colors.black};

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoginLink = styled.div``;
const HelpLink = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
`;

const FormSubfooter = () => {
  return (
    <SubfooterStyled>
      <LoginLink>
        {t('ALREADY_REGISTERED')}{' '}
        <InlineLink to={LOGIN}>{t('LOG_IN_HERE')}</InlineLink>
      </LoginLink>
      <HelpLink>
        {t('NEED_HELP')}{' '}
        <InlineAnchor href="mailto:support@anyroad.com">
          {t('CONTACT_US')}
        </InlineAnchor>
      </HelpLink>
    </SubfooterStyled>
  );
};

export default FormSubfooter;
